





















import { Component, Vue } from 'vue-property-decorator';
import PreviousDisplayItemsList from '@/components/display-items/PreviousDisplayItemsList.vue';
import {mapFields} from 'vuex-map-fields';

@Component({
    components: {
        PreviousDisplayItemsList
    },
    computed: mapFields('settings', [
        'order_top_first'
    ])
})
export default class DisplayItemHistory extends Vue {

    // Recalulate scroll by distance from bottom for changed page height
    private recalcBottomScroll() {

        // Get scrolling element
        const el = document.scrollingElement;
        if (el == null) {
            return;
        }

        const oldScrollHeight = el.scrollHeight;
        const scroll = el.scrollTop;

        // Base scroll on distance from page bottom
        const scrollDeltaBottom = oldScrollHeight - scroll;

        Vue.nextTick(() => {
           Vue.nextTick(() => {

                const newScrollHeight = el.scrollHeight;

                // Reset scroll
                el.scrollTop = newScrollHeight - scrollDeltaBottom;
            });
        });
    }
}
